import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders} from '@angular/common/http';
import { catchError  } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { CONFIG } from '../../_config/config';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TokenErrorInterceptorService implements HttpInterceptor {

 gateway = this.config.gateway;

  constructor(
    private http: HttpClient,
    private config: CONFIG,
    private router: Router
  ) {

  }

  intercept(req, next) {
    return next.handle(req).pipe(
      catchError(error => {
        let errorMessage = '';
        if (error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Client-side error: ${error.error.message}`;
        } else {
          // backend error
          errorMessage = `Server-side error: ${error.status} ${error.message}`;
        }
        if (error.error.error === 'invalid_token') {
          sessionStorage.removeItem('token'); // Eliminar token --
          this.router.navigateByUrl('/labviewer/login');
          return ;
        }
        console.log('ERROR INTERCEPTOR: ', errorMessage + ' -' + error);
        return throwError(error);
      })
    );
  }


}
